import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  Grid,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import { useLazyGetCmsQuery, useUpdateCmsMutation } from "../../services/cms";
import { useFormik } from "formik";
import * as Yup from "yup";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import PhoneInput from "react-phone-input-2";
import {
  useAddFAQMutation,
  useLazyGetFAQQuery,
  useDeleteFAQByIdMutation,
  useUpdateFAQByIdMutation,
} from "../../services/faq";
import moment from "moment";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import Pagination from "../../components/Panigation";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { isValidInput } from "../../utils/validations";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [aboutUs, setAboutUs] = useState<string>("");
  const [termCondition, setTermCondition] = useState<string>("");
  const [phoneCode, setPhoneCode] = useState("+91");
  const [updateCMS] = useUpdateCmsMutation();
  const [getCms] = useLazyGetCmsQuery();
  const [getAllData] = useLazyGetFAQQuery();
  const [phoneDisplay, setPhoneDisplay] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);

  //faq
  const [faq, setFaq] = useState<any>([]);
  const [updateData]: any = useUpdateFAQByIdMutation();
  const [deleteById] = useDeleteFAQByIdMutation();
  const [addData] = useAddFAQMutation();
  const [selectedId, setSelectedId] = useState<string>("");
  const [openDelete, setOpenDelete] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const { isAdd, isDelete } = usePermission({
    label: "Manage CMS",
    page_permission: "isView",
  });

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const totalPages = Math.ceil(totalCount / 10);
  const onPageChange = (newPage: any) => {
    setPage(newPage);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [faqData, setFaqData] = useState({ question: "", answer: "" });
  const [isEdit, setIsEdit] = useState(false);

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneDisplay(country?.dailcode + phone);
    setPhoneCode(country?.dialCode);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  //getFaq
  const getFaqList: any = async () => {
    setIsLoading(true);
    try {
      const response = await getAllData({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setFaq(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      } else {
        setIsLoading(false);
        setFaq([]);
      }
    } catch (error: any) {
      setIsLoading(false);
      showError(error?.data?.message || "");
    }
  };

  //Add Faq
  const addFaq: any = async () => {
    if (faqData?.question.trim() === "") {
      showError("Question is required");
      return;
    }
    if (faqData?.answer.trim() === "") {
      showError("Answer is required");
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        question: faqData?.question,
        answer: faqData?.answer,
      };

      const response = await addData({ body }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setFaqData({ question: "", answer: "" });
        showToast("FAQ added successfully");
        // setFaq((prevData: any) => [...prevData, body]);
        // getFaqList();
      } else {
        setIsLoading(false);
        setFaq([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsLoading(false);
      getFaqList();
    }
  };

  //update Faq
  const updateFaq = async (index: any) => {
    if (faqData.question.trim() == "") {
      showError("Faq question is required");
      return;
    }
    if (faqData.answer.trim() == "") {
      showError("Faq answer is required");
      return;
    }
    setIsLoading(true);
    const body = {
      question: faqData.question,
      answer: faqData.answer,
    };
    try {
      const response = await updateData({
        id: selectedId,
        body,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        showToast("FAQ updated successfully");
        // setFaq((prevData:any)=>[...prevData,body])
      } else {
        setIsLoading(false);
        setFaq([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsLoading(false);
      getFaqList();
    }
  };

  // delete FAQ
  const handleDeleteFaq = async (id: string) => {
    try {
      const response = await deleteById({ id }).unwrap();
      if (response.statusCode === 200) {
        showToast(response?.message || "Faq Deleted Successfully");

        getFaqList();
      } else {
        showError(response.message);
      }
    } catch (e: any) {
      showError(e?.data?.message);
    } finally {
      setIsLoading(false);
      getFaqList();
    }
  };

  const columns: GridColDef<(typeof faq)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "question",
      headerName: "Question",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "answer",
      headerName: "Answer",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "answer",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            {isAdd && (
              <IconButton
                onClick={() => {
                  setFaqData({
                    answer: row?.answer || "",
                    question: row?.answer || "",
                  });
                  setSelectedId(row?._id);
                  setOpenModal(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            )}
            {isDelete && (
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            )}
          </div>
        );
      },
    },
  ];

  //formick
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      updateCmsContact();
    },
  });

  // get Data
  const getCmsData = async () => {
    setIsLoading(true);
    try {
      const response = await getCms({}).unwrap();
      if (response.statusCode === 200) {
        setIsLoading(false);
        setPrivacyPolicy(response?.data?.privacyPolicy);
        setAboutUs(response?.data.aboutUs);
        formik.setFieldValue("email", response.data?.email);
        formik.setFieldValue("phone", response?.data?.phone);
        setPhoneCode(response?.data?.countryCode || "+91");
        setPhoneDisplay(response?.data?.countryCode + response?.data?.phone);
        setTermCondition(response?.data?.terms);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //update Data
  const updateCMSData = async (title = "") => {
    try {
      const body = {
        email: formik.values.email,
        countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
        phone: formik.values.phone,
        privacyPolicy: privacyPolicy,
        aboutUs: aboutUs,
        terms: termCondition,
      };

      const response = await updateCMS(body).unwrap();
      if (response.statusCode === 200) {
        showToast(title);
      }
    } catch (error: any) {
      showError(error?.data?.message);
      console.log(error);
    }
  };

  const updateCmsContact = async () => {
    updateCMSData("Contact detail updated successfully");
  };

  const updateCmsPrivacy = async () => {
    updateCMSData("Privacy Policy updated successfully");
  };

  const updateCmsAbout = async () => {
    updateCMSData(" About Us updated successfully");
  };

  const updateCmsTermCondition = async () => {
    updateCMSData("Terms & Condition updated successfully");
  };

  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    getFaqList();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="About Us" {...a11yProps(1)} />
              <Tab label="Privacy Policy" {...a11yProps(2)} />
              <Tab label="Terms & Condition" {...a11yProps(3)} />
              <Tab label="FAQ" {...a11yProps(4)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Email Address</label>
                <TextField
                  hiddenLabel
                  className="text_field"
                  type={"email"}
                  name="email"
                  variant="outlined"
                  fullWidth
                  value={formik.values.email}
                  onChange={(e) => {
                    if (e.target.value == " ") return;
                    if (e.target.value.length <= 50) formik.handleChange(e);
                    else showError("Email can't exceed 50 characters");
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                  placeholder="Email"
                  // onMouseOver={(e: any) => {
                  //   e.target.style.cursor = !isEditAllowed(8)
                  //     ? "not-allowed"
                  //     : "";
                  // }}
                />
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  country={"us"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  value={phoneDisplay}
                  onChange={handleChangePhone}
                  inputStyle={{ width: "100%" }}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <h6 className="err_msg">
                    {formik.touched.phone && formik.errors.phone}
                  </h6>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="form_btn">
              {isAdd && (
                <Button className="btn btn_primary" type="submit">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>
        {/*About*/}
        <CustomTabPanel value={valueTabs} index={1}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // showToast("CMS updated successfully");
              updateCmsAbout();
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {/* <Typography className="custom_label">About us </Typography> */}
                <EditText content={aboutUs} setContent={setAboutUs} />
              </Grid>
            </Grid>

            <div className="form_btn">
              {isAdd && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>

        {/*Privacy Policy*/}
        <CustomTabPanel value={valueTabs} index={2}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCmsPrivacy();
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {/* <Typography className="custom_label">
                      Privacy Policy{" "}
                    </Typography> */}
                <EditText
                  content={privacyPolicy}
                  setContent={setPrivacyPolicy}
                />
              </Grid>
            </Grid>
            <div className="form_btn">
              {isAdd && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>

        {/*FAQ*/}
        <CustomTabPanel value={valueTabs} index={4}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>
            <div className="right_s">
              {isAdd && (
                <Button
                  className="btn btn_primary"
                  onClick={() => {
                    setFaqData({ question: "", answer: "" });
                    setSelectedId("");
                    setIsEdit(false);
                    setOpenModal(true);
                  }}
                >
                  Add FAQ
                </Button>
              )}
            </div>
          </div>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={faq}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={isLoading}
            />
          </div>
          {/* <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className="v3"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faq.map((el: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell>{i + 1}</TableCell>
                    <TableCell>{el?.question}</TableCell>
                    <TableCell className="max_c2">
                      <p>{el?.answer}</p>
                    </TableCell>
                    <TableCell>
                      {moment(faq?.createdAt).format("YYYY-MM-DD") || "-"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => {
                            setFaqData({
                              answer: el?.answer || "",
                              question: el?.answer || "",
                            });
                            setSelectedId(el?._id);
                            setOpenModal(true);
                          }}
                        >
                          <img src="/static/images/edit2_icon.svg" alt="" />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setSelectedId(el?._id);
                            setOpenDelete(true);
                          }}
                        >
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer> */}
        </CustomTabPanel>
        {/*Term and Condition*/}
        <CustomTabPanel value={valueTabs} index={3}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // showToast("CMS updated successfully");
              // updateCmsAbout();
              updateCmsTermCondition();
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {/* <Typography className="custom_label">About us </Typography> */}
                <EditText
                  content={termCondition}
                  setContent={setTermCondition}
                />
              </Grid>
            </Grid>

            <div className="form_btn">
              {isAdd && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>
      </div>
      {/* <Pagination
        module={faq}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages} totalCount={
          totalCount} setPage={setPage }      /> */}

      <ConfirmationModal
        text="Are you sure to delete this Faq"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => handleDeleteFaq(selectedId)}
      />

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        faqData={faqData}
        setFaqData={setFaqData}
        addFaq={selectedId ? updateFaq : addFaq}
        id={selectedId}
      />
    </MainContainer>
  );
};

export default ManageCms;
